import React, { useEffect, useState } from "react";
import CountUp from "react-countup";

function Loading({ onFinish }) {
  const [isDone, setIsDone] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsDone(true);

      setTimeout(() => {
        onFinish();
      }, 1000);

    }, 4500);

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <section
      className={`fixed inset-0 z-[9999] bg-[#050505] flex items-center justify-center overflow-hidden transition-all duration-1000 ease-in-out ${isDone ? "opacity-0 scale-110 pointer-events-none" : "opacity-100"
        }`}
    >
      {/* 1. Grainy Texture Overlay */}
      <div className="absolute inset-0 opacity-[1] pointer-events-none contrast-150 brightness-100"
        style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3BaseFilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/feFilter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")` }}>
      </div>

      {/* 2. Perspective Grid Floor */}
      <div className="absolute inset-0 [perspective:500px] pointer-events-none">
        <div
          className="absolute inset-0 h-[200%] w-full bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:40px_40px] [transform:rotateX(45deg)_translateY(-25%)]"
          style={{ animation: 'gridMove 20s linear infinite' }}
        />
      </div>

      {/* 3. Floating System Strings (Minimalist Tech) */}
      <div className="absolute inset-0 flex flex-col justify-between p-10 opacity-20 pointer-events-none font-mono text-[8px] text-white">
        <div className="flex justify-between uppercase tracking-[0.5em]">
          <span>System_Init: 0x882A</span>
          <span>Buffer_Load: Stable</span>
        </div>
        <div className="flex justify-between uppercase tracking-[0.5em]">
          <span>Loc: 10°06'01.8"N, 76°26'31.7"E</span>
          <span>Ver: 2.0.4_BETA</span>
        </div>
      </div>

      <div className="relative flex flex-col items-center">
        {/* The Main Number with Glow Pulse */}
        <div className={`relative transition-all duration-[1000ms] cubic-bezier(0.23, 1, 0.32, 1) ${isDone ? 'scale-150 blur-xl opacity-0' : 'scale-100'}`}>
          <div className="flex items-center group">
            <CountUp
              className="text-[22vw] font-[1000] text-white leading-none tracking-tighter drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]"
              end={100}
              duration={4.2}
            />
            <span className="text-[4vw] text-[#CFEF00] font-black italic self-end mb-[3vw] ml-4 animate-pulse">%</span>
          </div>

          {/* Decorative Framing Hooks */}
          <div className="absolute -top-6 -left-6 w-12 h-[1px] bg-[#CFEF00]/50" />
          <div className="absolute -top-6 -left-6 w-[1px] h-12 bg-[#CFEF00]/50" />

          <div className="absolute -bottom-6 -right-6 w-12 h-[1px] bg-[#CFEF00]/50" />
          <div className="absolute -bottom-6 -right-6 w-[1px] h-12 bg-[#CFEF00]/50" />
        </div>

        {/* Status Text with Dynamic Underline */}
        <div className={`mt-12 flex flex-col items-center transition-all duration-700 ${isDone ? 'opacity-0 -translate-y-4' : 'opacity-100'}`}>
          <p className="text-[#CFEF00] font-mono text-[5px] md:text-[10px] tracking-[1em] uppercase mb-2 animate-pulse">
            Optimizing_Assets
          </p>
          {/* <div className="w-48 h-[1px] bg-white/10 relative overflow-hidden">
            <div className="absolute inset-0 bg-[#CFEF00] w-1/3 animate-shimmer"
              style={{
                animation: 'loadProgress 4.5s cubic-bezier(0.65, 0, 0.35, 1) forwards'
              }} />
          </div> */}
        </div>
      </div>

      {/* Extreme Bottom Progress Bar */}
      <div className="absolute bottom-0 left-0 w-full h-[4px] bg-white/5">
        <div
          className="h-full bg-[#CFEF00] shadow-[0_0_25px_#CFEF00]"
          style={{
            animation: 'loadProgress 4.5s cubic-bezier(0.65, 0, 0.35, 1) forwards'
          }}
        />
      </div>

      <style>{`
        @keyframes gridMove {
          0% { transform: rotateX(45deg) translateY(0); }
          100% { transform: rotateX(45deg) translateY(40px); }
        }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(300%); }
        }
        @keyframes loadProgress {
          0% { width: 0%; }
          100% { width: 100%; }
        }
      `}</style>
    </section>
  );
}

export default Loading;